module.exports = __webpack_public_path__ + "img/login-img@3x.0df99fbe.png";